import Checkbox from '@anm/components/form/Checkbox';
import { FC } from 'react';

import { DestinationInfo } from '../destination_management/DestinationList';

import { Row } from './Wrapper';
import { RowWithCheckboxProps } from './types';

const RowWithCheckbox: FC<RowWithCheckboxProps> = ({ id, isChecked, onChange, ...destinationProps }) => (
  <Row>
    <DestinationInfo {...destinationProps} />
    <Checkbox checked={isChecked} onChange={() => onChange(id)} />
  </Row>
);

export default RowWithCheckbox;
